// extracted by mini-css-extract-plugin
export var quillEditor = "_mp-1";
export var variable = "_mp-0";